import get from 'lodash.get';

const getCustomGradients = (state) => get(state, 'ws.site.meta.customization.customGradients', []);

export default getCustomGradients;
